/* CTA arrows for pill buttons on the homepage and story sections.
   One rule, decided from what the button does:
     scrolls within this page (href "#...", or this page's path + hash)  -> arrow-down
     opens a pop-up or overlay (quiz, quick view, compare, review form)  -> arrow-up-right
     leaves the page (any other link)                                     -> arrow-right
   The arrow is a reserved, always-laid-out box after the label (no shift); CSS in pb-tokens.css shows it on
   hover/focus with a fine pointer and always on touch. Icons come from snippets/pb-icon via <template id="pb-cta-ics">.
   Header, cart drawer and add-to-cart buttons are never touched. */
(function(){
  var D = document;
  var SEL = '.sh__cta, .pbct__all, .pbct__cta--ghost, .pbqe__btn, .pbr-pill, .pbes__cta, .pbhb__cta, .pbd__cta, .rw__btn, '
          + '.pb-btn, .ab-cta, .abh-c1, .abh-c2, .pbbg__cta, .bf__pvi, .bf__cmpall, .pbvr__atc--pv, .pb-bss__cmp, [data-cta-arrow]';
  var SKIP = 'header, .pbt-dock, #shopify-section-header, [id$="__header"], .cart-drawer, #CartDrawer, [id*="cart-drawer"], form[action*="/cart/add"], .pb-buy-bar, .pbqv';
  var OVERLAY = '[data-pbq-open], [data-preview], [data-pbqv-pill], [data-pvi], [data-pbr-write], [data-pb-compare-all], [data-cmpall], [aria-haspopup], [data-cta-overlay], [data-quickview]';
  var ics = null;
  function icon(kind){
    if (!ics){ var t = D.getElementById('pb-cta-ics'); if (!t) return null; ics = t.content || t; }
    var src = ics.querySelector('[data-k="' + kind + '"]'); return src ? src.cloneNode(true) : null;
  }
  function kindOf(el){
    var forced = el.getAttribute('data-cta-arrow'); if (forced === 'none') return '';
    if (forced) return forced;
    if (el.matches(OVERLAY)) return 'up-right';
    var h = el.getAttribute('href');
    if (h == null) return '';                          /* a plain button with no known overlay: leave it */
    if (h.charAt(0) === '#') return h.length > 1 ? 'down' : '';
    try {
      var u = new URL(h, location.href);
      if (u.origin === location.origin && u.pathname === location.pathname && u.hash) return 'down';
    } catch (e) {}
    return 'right';
  }
  function run(root){
    var list = (root || D).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++){
      var el = list[i];
      if (el.hasAttribute('data-cta-ar') || el.closest(SKIP)) continue;
      if (el.matches('[name="add"], .add_to_cart_button, [data-add], [data-atc]')) continue;
      /* a button that already draws its own arrow keeps it (no doubles) */
      /* a button that already carries an icon (e.g. the preview zoom mark) already hints its action: no arrow */
      if (el.querySelector('svg, img, [class*="arrow"], .pb-ic--arrow-down, .pb-ic--arrow-right, .pb-ic--arrow-up-right')) { el.setAttribute('data-cta-ar', ''); continue; }
      var k = kindOf(el); if (!k) { el.setAttribute('data-cta-ar', ''); continue; }
      var ic = icon(k); if (!ic) return;               /* icons not on the page: try again later */
      ic.removeAttribute('data-k'); ic.className = 'pb-cta-ar';
      el.appendChild(ic); el.setAttribute('data-cta-ar', k);
    }
  }
  function boot(){ run(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  D.addEventListener('shopify:section:load', function(e){ run(e.target); });
  window.pbCtaArrows = run;
})();
